<template>
  <password
    v-model="password"
    :defaultClass="'form-control'+(error?' is-invalid':'')"
    :name="id"
    :placeholder="placeholder"
    :id="id"
    :toggle="true"
    :showStrengthMeter="showStrengthMeter"
    :badge="badge"
    :secureLength="secureLength"
  />
</template>

<script>
  import Password from 'vue-password-strength-meter'
  export default {
    components: { Password },
    data: () => ({
      password: null,
      secureLength: 8, // minimum password
    }),
    props: {
      id: {
        type: String
      },
      placeholder: {
        type: String
      },
      error: {
        type: Boolean,
        default: false
      },
      showStrengthMeter: {
          type: Boolean,
          default: true
      },
      badge: {
            type: Boolean,
            default: true
        }
    }
  }
</script>

<style scoped>
    .Password {
        max-width: none;
    }

    .Password >>> .Password__badge, .Password >>> .Password__toggle {
        margin-right: 1rem;
    }

    .Password >>> .Password__badge {
        border-radius: .3rem;
        padding: .2rem;
        width: 2rem;
        height: 1.4rem;
        font-size: 1rem;
        text-align: center;
    }

</style>

